import { FC } from 'react';
import { Loader } from '../../components/loading/Loader';

interface Props {
  fullPage?: boolean;
}

export const Loading: FC<Props> = ({ fullPage = true }) => {
  return (
    <div style={{ height: fullPage ? '100vh' : 'calc(100vh - 250px)', top: fullPage ? 0 : '250px'}} className={`absolute left-0 w-screen flex items-center justify-center`}>
      <Loader className="w-10 h-10 text-primary-800" />
    </div>
  );
};
